var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('video',{ref:"videoPlayer",staticClass:"video-js vjs-default-skin vjs-big-play-centered",attrs:{"x-webkit-airplay":"true","webkit-playsinline":"","playsinline":"true"}})])}
var staticRenderFns = []

export { render, staticRenderFns }